import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Vision from "@/components/landing/Vision";
import Marquee from "@/components/landing/Marquee";
import Pipeline from "@/components/landing/Pipeline";
import Formats from "@/components/landing/Formats";
import Status from "@/components/landing/Status";
import Philosophy from "@/components/landing/Philosophy";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#090909] font-sans text-[#F5F5F5] antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Vision />
        <Marquee />
        <Pipeline />
        <Formats />
        <Status />
        <Philosophy />
        <Waitlist />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
